import {CopilotCodeReviewFeedback} from '@github-ui/copilot-code-review-feedback/CopilotCodeReviewFeedback'
import {useAutomatedReviewFeedback} from '../../../hooks/use-automated-review-feedback'

export interface AutomatedReviewFeedbackProps {
  automatedCommentId: string
  feedbackOptions: Array<{label: string; value: string}>
  basePath: string
}

export function AutomatedReviewFeedback({automatedCommentId, feedbackOptions, basePath}: AutomatedReviewFeedbackProps) {
  const {feedbackPath} = useAutomatedReviewFeedback(automatedCommentId, basePath)

  return (
    <div data-testid={`automated-review-feedback-${automatedCommentId}`}>
      <CopilotCodeReviewFeedback
        commentId={automatedCommentId}
        feedbackPath={feedbackPath}
        feedbackOptions={feedbackOptions}
      />
    </div>
  )
}

try{ AutomatedReviewFeedback.displayName ||= 'AutomatedReviewFeedback' } catch {}